import { useEffect, useState } from 'react'
import api from '../lib/api'
import type { ModuleKey, Modules } from '../lib/modules'

// Réglages > Modules : allumer / éteindre une partie de l'appli.
// Éteindre ne supprime rien : pages et données restent, elles sont juste masquées.
const ORDER: ModuleKey[] = ['rh', 'conges', 'badgeuse', 'assistant', 'planningAuto']

export default function ModulesPanel() {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  const canEdit = user.role === 'super_admin'
  const [modules, setModules] = useState<Modules | null>(null)
  const [labels, setLabels] = useState<Record<string, string>>({})
  const [busy, setBusy] = useState<ModuleKey | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    api.get('/organization/modules')
      .then(r => { setModules(r.data.modules); setLabels(r.data.labels || {}) })
      .catch(() => setError('Impossible de lire les modules'))
  }, [])

  async function toggle(key: ModuleKey) {
    if (!modules || !canEdit) return
    setBusy(key); setError('')
    try {
      const r = await api.put('/organization/modules', { modules: { [key]: !modules[key] } })
      setModules(r.data.modules)
      localStorage.setItem('modules_manager', JSON.stringify(r.data.modules))
    } catch {
      setError('Enregistrement refusé')
    } finally {
      setBusy(null)
    }
  }

  if (!modules) return <p className="text-sm text-gray-400">{error || 'Chargement…'}</p>

  return (
    <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
      <div className="p-4">
        <p className="text-sm text-gray-600">
          Un module éteint disparaît des menus (ordinateur et téléphone). Rien n'est supprimé :
          en le rallumant, tout revient comme avant.
        </p>
        {!canEdit && <p className="text-xs text-amber-600 mt-2">Seul le super administrateur peut modifier ces réglages.</p>}
        {error && <p className="text-xs text-red-600 mt-2">{error}</p>}
      </div>
      {ORDER.map(key => (
        <div key={key} className="flex items-center justify-between gap-4 p-4">
          <span className="text-sm text-gray-800">{labels[key] || key}</span>
          <button
            onClick={() => toggle(key)}
            disabled={!canEdit || busy !== null}
            aria-pressed={modules[key]}
            className={`relative w-11 h-6 rounded-full transition-colors flex-shrink-0 disabled:opacity-50 ${modules[key] ? 'bg-green-500' : 'bg-gray-300'}`}>
            <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-all ${modules[key] ? 'left-5' : 'left-0.5'}`} />
          </button>
        </div>
      ))}
    </div>
  )
}
